/**
 * Базовый URL бэкенда (без завершающего слэша).
 * Обязательно задайте REACT_APP_API_URL в .env.
 * Для локальной разработки: REACT_APP_API_URL=http://localhost:5001
 */
const raw =
    process.env.REACT_APP_API_URL ||
    process.env.REACT_APP_API_BASE_URL ||
    (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:5001');

export const API_BASE_URL = String(raw).replace(/\/$/, '');

/** Полный URL к эндпоинту API, например apiUrl('/api/auth/login'). */
export function apiUrl(path) {
    const p = path.startsWith('/') ? path : `/${path}`;
    return `${API_BASE_URL}${p}`;
}
